import { UserAgreementAcceptGaurd } from './service/common/user-agreement-acceptguard.service';
import { LogoutComponent } from './logout.component';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RootComponent } from './root/root.component';
import { MainPageComponent } from './main-page/main-page.component';
import { RouteGuard } from './service/common/routeguard.service';
import { OauthcallbackComponent } from './oauthcallback/oauthcallback.component';
import { MainPageSaveGuard } from './main-page/main-page-saveguard.service';
import { StpConfigureComponent } from './main-page/stp-configure/stp-configure.component';
import { ConnectorGridComponent } from './main-page/master-data/connectors/connector-grid/connector-grid.component';
import { BasesGridComponent } from './main-page/master-data/bases/bases-grid/bases-grid.component';
import {AppComponent}  from './dbm.data.store.component';


export const appRoutes: Routes = [
  {
     path: '',
     component: AppComponent,
     children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch:'full'
      },
      {
        path: 'logout',
        component: LogoutComponent,
        data: {
          breadcrumb: 'logout'
        }
      },
      {
       path: 'main',
       component: MainPageComponent,
       data: {
        breadcrumb: 'main-page'
       }
      },
      { path: 'stp-configure', component: StpConfigureComponent },
        {
         path: '**', redirectTo: 'main',
         data: {
           breadcrumb: 'main-page'
        },
        canActivate: [RouteGuard]
      }
     ]
  }
];
